export const REG_SEARCH_HEAD_SPACE = new RegExp(/^ /); // Start with space
export const REG_SEARCH_TAIL_SPACE = new RegExp(/([ ]{2,}).*$/); // More than 1 space at tail
export const REG_SEARCH_MIDDLE_SPACE = new RegExp(/(\w|\W)[ ]{2,}(\w|\W)/); // More than 1 space between words or non-words
